var React = require('react');

function FlagMv (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M503.172 423.725H8.828A8.829 8.829 0 010 414.897V97.104a8.829 8.829 0 018.828-8.828h494.345a8.829 8.829 0 018.828 8.828v317.793a8.83 8.83 0 01-8.829 8.828z","fill":"#ff4b55","key":0}),React.createElement("path",{"d":"M441.379 158.898v194.207H70.621V158.898h370.758","fill":"#73af00","key":1}),React.createElement("path",{"d":"M238.378 256.027c0-33.425 22.767-61.417 53.587-69.525 1.026-.27.952-1.754-.1-1.889a66.738 66.738 0 00-8.533-.566c-39.785 0-71.992 32.202-71.992 71.98 0 39.606 32.207 71.896 71.992 71.896 2.898 0 5.745-.209 8.544-.569 1.052-.136 1.125-1.619.1-1.889-30.826-8.121-53.598-36.154-53.598-69.438z","fill":"#f5f5f5","key":2})]);
}

FlagMv.defaultProps = {"viewBox":"0 0 512.001 512.001"};

module.exports = FlagMv;

FlagMv.default = FlagMv;
